import React from "react";
import axios from "axios";
import { API } from "@aws-amplify/api";
import { getCoupon, listCoupons } from "graphql/queries";
import { Actions as NOTIFICATIONACTIONS } from "store/notifications/action";
import { REST_API } from "../../constants";

const Types = {
  COUPON_GET_ITEM: "COUPON_GET_ITEM",
  COUPON_UPDATE_ITEM: "COUPON_UPDATE_ITEM",
  COUPON_CREATE_ITEM: "COUPON_CREATE_ITEM",
  COUPON_CLEAR_ITEM: "COUPON_CLEAR_ITEM",
  COUPON_GET_LIST: "COUPON_GET_LIST",
  COUPON_DELETE_ITEM: "COUPON_DELETE_ITEM",
};

const DISCOUNT_TYPE = {
  FIXED: "FIXED",
  PERCENTAGE: "PERCENTAGE",
};

const dispatchEvent = (type, payload) => ({ type, payload });

const displayNotification = (message, icon, dispatch) => {
  dispatch(
    NOTIFICATIONACTIONS.addNotification(
      {
        title: <React.Fragment>{message}</React.Fragment>,
        icon,
      },
      4000
    )
  );
};

const clearItem = () => {
  return (dispatch, getState) => {
    dispatch(dispatchEvent(Types.COUPON_CLEAR_ITEM));
  };
};

const getItem = (id) => {
  return (dispatch, getState) => {
    const variables = { id };
    const request = API.graphql({
      query: getCoupon,
      variables,
      authMode: "AMAZON_COGNITO_USER_POOLS",
    });
    request.then((response) => {
      dispatch(dispatchEvent(Types.COUPON_GET_ITEM, response.data));
    });
  };
};

const saveItem = (item) => {
  return (dispatch, getState) => {
    const { coupon, businessID } = getState();
    let data = { coupon: { ...item, businessID } };
    const couponID = coupon?.item?.id;
    if (couponID) {
      data.coupon.id = couponID;
      data.coupon._version = coupon.item?._version;
    }
    const method = couponID ? `put` : `post`;
    return axios({
      method,
      url: `/coupon`,
      data,
      baseURL: REST_API,
    })
      .then((response) => {
        const savedCoupon = response?.data?.coupon;
        if (!savedCoupon)
          return displayNotification(
            "Unable to save coupon. Please try again later.",
            "warning",
            dispatch
          );

        dispatch(
          dispatchEvent(
            method === "post"
              ? Types.COUPON_CREATE_ITEM
              : Types.COUPON_UPDATE_ITEM,
            savedCoupon
          )
        );
        displayNotification(
          `${savedCoupon?.name} has been saved`,
          "success",
          dispatch
        );
      })
      .catch((error) => {
        return displayNotification(
          "Unable to save coupon. Please try again later.",
          "warning",
          dispatch
        );
      });
  };
};

const getList = (limit, nextToken) => {
  return (dispatch, getState) => {
    const variables = { limit, nextToken };
    const request = API.graphql({
      query: listCoupons,
      variables,
      authMode: "AMAZON_COGNITO_USER_POOLS",
    });
    request
      .then((response) => {
        if (!response.data?.listCoupons?.items) throw new Error();
        dispatch(dispatchEvent(Types.COUPON_GET_LIST, response?.data));
      })
      .catch((error) => {
        console.error("[coupon] getList | ", error);
        return displayNotification(
          "Unable to get coupon list. Please try again later.",
          "warning",
          dispatch
        );
      });
  };
};

const deleteItem = (id) => {
  return (dispatch, getState) => {
    axios({
      method: `delete`,
      url: `/coupon/${id}`,
      baseURL: REST_API,
    })
      .then(async (response) => {
        const deleteCoupon = response.data;
        if (deleteCoupon.success) {
          dispatch(dispatchEvent(Types.COUPON_DELETE_ITEM, response.data));
          displayNotification("Coupon has been deleted.", "success", dispatch);
        } else {
          displayNotification("Error deleting coupon.", "warning", dispatch);
        }
      })
      .catch((error) => {
        return displayNotification(
          error?.response?.status == 409
            ? error?.response?.data?.error
            : "Error deleting coupon.",
          "warning",
          dispatch
        );
      });
  };
};

const Actions = {
  saveItem,
  getItem,
  getList,
  clearItem,
  deleteItem,
};

export { Types, Actions, DISCOUNT_TYPE };
